// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

//先引入第三方组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css';
import axios from './api/index'


//后引入router 解决自己写的样式被覆盖
import router from './router'
import store from './store/index'
import { from } from '_array-flatten@2.1.2@array-flatten';

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.use(ElementUI);



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    data: {
        eventHub: new Vue()
    }
})


// WEBPACK FOOTER //
// ./src/main.js